import {
   FeatureNotEnabledFault,
   QuotaExceededFault,
   TranscriptionCredentialsFault,
   TranscriptionTokenGenerateCommand,
   TranscriptionTokenResult,
} from '@dreryk/egabinet-ai-assistant-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { dispatchAiAssistantTokensQuotaSnackbarEvent } from '../shared/dispatchAiAssistantTokensQuotaSnackbarEvent';
import { translationKeys } from '../translations';

import { AI_ASSISTANT_FAULT_HANDLERS } from './faultHandlers';

type CredentialsFaultUnion = FeatureNotEnabledFault | QuotaExceededFault | TranscriptionCredentialsFault;

export type ElevenLabsCredentialsInput = {
   showSpeakerLabel: boolean;
};

export const useElevenLabsCredentials = (): UseCqrsCommandResult<
   TranscriptionTokenResult,
   ElevenLabsCredentialsInput,
   CredentialsFaultUnion
> => {
   return useCqrsCommand<TranscriptionTokenResult, ElevenLabsCredentialsInput, CredentialsFaultUnion>(
      (input) => {
         const command = new TranscriptionTokenGenerateCommand();
         command.showSpeakerLabel = input.showSpeakerLabel;
         return command;
      },
      {
         onFault: {
            ...AI_ASSISTANT_FAULT_HANDLERS,
            'egabinet-ai-assistant-frontend-api:QuotaExceededFault': (): void => {
               dispatchAiAssistantTokensQuotaSnackbarEvent('EXHAUSTED');
            },
            'egabinet-ai-assistant-frontend-api:TranscriptionCredentialsFault': (): void => {
               dispatchSnackbarNegativeEvent(translationKeys.faults.transcriptionCredentialsUnavailable);
            },
         },
      }
   );
};
